let elements = [];

function addClass() {
  for (const entry of elements) {
    if (entry.el == this && entry.value != "") {
      entry.el.classList.add(entry.value);
    }
  }
}

function removeClass() {
  for (const entry of elements) {
    if (entry.el == this && entry.value != "") {
      entry.el.classList.remove(entry.value);
    }
  }
}

export default {
  inserted(el, binding) {
    const { value = "" } = binding;
    elements.push({
      el,
      value: value
    });
  },

  bind(el, binding, vnode) {
    el.addEventListener("mouseenter", addClass);
    el.addEventListener("mouseleave", removeClass);
  },
  unbind(el, binding, vnode) {
    el.removeEventListener("mouseenter", addClass);
    el.removeEventListener("mouseleave", removeClass);
  }
};
